import { TurbineIcon } from './TurbineIcon';

/**
 * author: Hans Böhm
 * id 1F12944F-0802-431A-AA2C-7E0FEB23829B
 * name turbine
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/turbine.svg
 * tags
 * - Transportation + Flying 
 */
export const JetEngineIcon = TurbineIcon;
export default JetEngineIcon